// extracted by mini-css-extract-plugin
export default {"backdrop":"style_backdrop__4YeTj","modal":"style_modal__YYu5E","buttons":"style_buttons__u04Y4","cancel":"style_cancel__G1g04","confirm":"style_confirm__jBaLF"};